import React, { useState } from "react";
import { connect } from "react-redux";
import { OrgDropdown } from "../org/OrgDropdown";
import { dl_insuranceActions } from "../../actions";
import { IDENTITY_AND_INSURANCE_PAGE_GROUP_ID } from "../../constants/constants.js";
import {DateTimeDisplay} from "../common/DateTimeDisplay";

// Copied from EditDealName
function DocumentSubmission(props) {
  const {
    deal_or_identity_jacket,
    org_id,
    newToken,
    dl_insurances,
    recently_added,
  } = props;
  const submitted_at = new Date(deal_or_identity_jacket.date_added);

  const custdate = deal_or_identity_jacket?.customer_license_exp_date;

  var expiration_display  = "";
  if (custdate  && custdate !== null) {
    expiration_display = custdate;
  }
  
  // let expiration = new Date(deal_or_identity_jacket?.customer_license_exp_date || "1970");

  // var expiration_display = <DateTimeDisplay date={new Date(expiration)} hide_time={true} />;

  /*
  if (expiration < new Date()) {
    expiration_display = <span className="dlInsuranceListingExpiredLicense">
      {expiration_display}
    </span>
  }
*/
  /**
   * First loop through dealjacket groups to get single DL front image, then
   * loop through the rest of the jacket for Details.
   */
  let class_name = props.recently_added ? "dlInsuranceSubmission dlInsuranceRecentlyAdded" : "dlInsuranceSubmission";

  if (dl_insurances.current_submission_selected) {
    if (dl_insurances.current_submission_selected.deal_jacket_id === deal_or_identity_jacket.deal_jacket_id) {
      class_name += " active";
    } else {
      class_name += " inactive";
    }
  }

  return (

    <div className={class_name} key={deal_or_identity_jacket.deal_jacket_id}>
        {recently_added ? "" :
          <input name="dlInsuranceSelection"
            type="radio"
            onChange={e => props.selectSubmissionSet(deal_or_identity_jacket)}
            value={deal_or_identity_jacket.deal_jacket_id}
            id={deal_or_identity_jacket.deal_jacket_id} />}

    <label htmlFor={deal_or_identity_jacket.deal_jacket_id} >

      <div className="dlInsuranceListingImage">
        {deal_or_identity_jacket.groups?.map((group) => {
            if (group.page_group_id === IDENTITY_AND_INSURANCE_PAGE_GROUP_ID) {
              const img = group.pages[0].image_path;
              const page_id = group.pages[0].page_id;
              var current_rotation = dl_insurances.image_rotations[page_id] || 0;
                return (
                  <React.Fragment key={deal_or_identity_jacket.deal_jacket_id}>
                    <img
                      className={"dlInsuranceDriverLicense rot" + current_rotation}
                      src={img + "?t=" + newToken}
                      alt="Driver License Thumbnail"
                    />
                    <div
                      onClick={
                        e => {
                          current_rotation++;
                          if (current_rotation === 4) current_rotation = 0;
                          props.setImageRotation(page_id, current_rotation);
                        }
                      }
                      className="rotate-document">
                      ⟳
                    </div>
                  </React.Fragment>
                );
            }
            return "";
        })}
      </div>


      <div className="dlInsuranceListingDetails">
        <h4>{deal_or_identity_jacket.customer_name} </h4>
        {recently_added ?
          <>
            <p>Added to {deal_or_identity_jacket.deal_jacket_name}</p>
            <p>Issuing State: {deal_or_identity_jacket?.customer_license_state}</p>
            <p>License Number: {deal_or_identity_jacket?.customer_license_number}</p>
            <p>Expiration Date: {expiration_display}</p>
          </>
          :
          <>
            <p>Submitted: {submitted_at.toLocaleDateString()} {submitted_at.toLocaleTimeString()}</p>
            <p>Issuing State: {deal_or_identity_jacket?.customer_license_state}</p>
            <p>License Number: {deal_or_identity_jacket?.customer_license_number}</p>
            <p>Expiration Date: {expiration_display}</p>
          </>
        }
      </div>
      </label>

    </div>
  );
}

function mapStateToProps(state) {
  const { ingestion, assignDealNumber, dl_insurances } = state;
  return {
    ingestion,
    dl_insurances
  };
}

const actionCreators = {
  selectSubmissionSet: dl_insuranceActions.selectSubmissionSet,
  setImageRotation: dl_insuranceActions.setImageRotation,
};

const connectedDocumentSubmission = connect(
  mapStateToProps,
  actionCreators
)(DocumentSubmission);
export { connectedDocumentSubmission as DocumentSubmission };
